import './StateList.css';

import classNames from 'classnames';
import type { FC, ReactNode } from 'react';

export interface StateListItemProps {
  children: ReactNode;
  className?: string;
  type: 'positive' | 'negative';
}

export const StateListItem: FC<StateListItemProps> = (props) => (
  <div className={classNames('flex items-center', props.className)}>
    <span
      className={classNames(
        'state-list__item',
        {
          negative: 'bg-red-400',
          positive: 'bg-green-400',
        }[props.type],
      )}
    />
    {props.children}
  </div>
);
